<template>


  <b-row vh="100vh" align-v="center" no-gutters>

    <b-col md="3">
      <div class="login-pane">
        <img :src="api('static/img/logos/shoelabel.svg')" height="15px"/>
        <b-form>
          <b-form-group id="input-group-1" label-for="input-1">
            <b-form-input
                id="input-1"
                v-model="login"
                type="text"
                placeholder="login"
                required></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-2" label-for="input-2">
            <b-form-input
                id="input-2"
                v-model="password"
                type="password"
                placeholder="password"
                required></b-form-input>
          </b-form-group>

          <b-button variant="primary" v-on:click="logIn">zaloguj</b-button>

        </b-form>
      </div>
    </b-col>
    <b-col md="9" class="login-image">
      <img :src="api('static/img/login.png')" width="100%"/>
    </b-col>
  </b-row>


</template>

<script>

import {api} from '@/utils'

export default {
  name: 'LoginPage',
  props: ["axios"],
  data: function () {
    return {
      login: null,
      password: null
    }
  },
  methods: {
    logIn: function () {
      this.axios.post(api("login"), {login: this.login, password: this.password})
          .then(resp => this.$emit("login_success", resp.data))
          .catch(error => this.$emit("login_error", error.response.data.message))
    },
    api(url) {
      return api(url)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login-pane {
  padding: 2em;
}

.login-pane img {
  margin-bottom: 1em;
}
</style>
